import {Section} from '@primer/react-brand/esm'
import {CopilotLogoSuite} from '../../_components/CopilotLogoSuite/CopilotLogoSuite'

import styles from './HeroSection.module.css'

import type {HeroSectionContent} from '../../content'

import {HeroIntro} from '../../_components/HeroIntro/HeroIntro'
import {HeroTabs} from '../../_components/HeroTabs/HeroTabs'

type Props = {
  contentfulContent: HeroSectionContent
  hasSubnav?: boolean
}

export function HeroSection(props: Props) {
  const {contentfulContent, hasSubnav = false} = props

  const sectionId = contentfulContent.section.fields.htmlId

  const intro = contentfulContent.intro
  const tabs = contentfulContent.tabs
  const logoSuite = contentfulContent.logoSuite

  return (
    <Section id={sectionId} className={styles.HeroSection} data-has-subnav={hasSubnav}>
      {intro ? <HeroIntro contentfulContent={intro} /> : null}
      {tabs ? <HeroTabs component={tabs} heading={intro?.fields.heading} /> : null}

      <Section
        as="div"
        paddingBlockStart="condensed"
        paddingBlockEnd="condensed"
        variant="gridline"
        data-hide-gridline="top"
        data-padding-inline="0"
      >
        {logoSuite ? <CopilotLogoSuite component={logoSuite} location="hero" /> : null}
      </Section>
    </Section>
  )
}
